export const CHANGE_TYPE = "CHANGE_TYPE";
export const CLEAR_TYPE = "CLEAR_TYPE";
export const INIT_INCL_TAX_TYPE = "INIT_INCL_TAX_TYPE";
